export default "__VITE_ASSET__BmaTVzc9__"